export default __webpack_public_path__ + "static/media/total-credits.9f60441f.svg";